import type { OrgId } from '../shared/ids';
import type { CoverageRequest, CoverageRequestId, CoverageRequestStatus } from './coverage-request';
import type { OrderLineItem, PricingSnapshot } from './order-line-item';

export type CoverageRequestSubmitInput = {
  readonly orgId: OrgId;
  readonly items: readonly OrderLineItem[];
  readonly pricingSnapshot: PricingSnapshot;
};

export type CoverageRequestResolveResult = {
  readonly success: boolean;
  readonly error?: string;
};

export type CoverageRequestListResult = {
  readonly requests: readonly CoverageRequest[];
  readonly requesterNames: ReadonlyMap<string, string>;
};

export abstract class CoverageRequestRepository {
  abstract forOrg(orgId: OrgId): Promise<readonly CoverageRequest[]>;

  /**
   * Cross-org admin view. Returns requests with requester display-name
   * resolution joined in. Authorisation is enforced server-side.
   */
  abstract listAll(): Promise<CoverageRequestListResult>;

  abstract submit(input: CoverageRequestSubmitInput): Promise<{ requestId: CoverageRequestId }>;

  abstract resolve(
    requestId: CoverageRequestId,
    status: CoverageRequestStatus,
    notes: string | null
  ): Promise<CoverageRequestResolveResult>;
}
